import {createTheme} from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main : '#5855D6'
        },
        secondary: {
            main : '#072448'
        },
        background: {
            default: '#F0EFF5'
        }
    },

})

export default theme;
